import {
  Box,
  Typography,
  Link as MLink,
  Stack,
  Container,
  Button,
  Divider
} from '@mui/material';
import { Link } from 'react-router-dom';
import { site } from 'config/site';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{ 
        mt: 8, 
        pt: 8, 
        pb: 4, 
        background: '#070A11', // Very dark for footer
        borderTop: '1px solid rgba(255,255,255,0.05)'
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 4, md: 2 }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', md: 'center' }}
          sx={{ mb: 4 }}
        >
          {/* Logo & Info */}
          <Stack direction="row" spacing={2} alignItems="center">
            <img
              src={process.env.PUBLIC_URL + '/logos/base_icon_transparent_background.png'}
              width="40"
              height="40"
              alt="Rolsys"
              style={{ filter: 'drop-shadow(0 0 10px rgba(59,130,246,0.3))' }}
            />
            <Box>
              <Typography variant="h6" sx={{ color: '#F8FAFC', fontWeight: 700, lineHeight: 1.2 }}>
                Rolsys Solutions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {site.slogan}
              </Typography>
            </Box>
          </Stack>

          {/* Links & Support */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center">
            <MLink
              component={Link}
              to="/legal/aviso-de-privacidad"
              underline="hover"
              sx={{ color: '#94A3B8', '&:hover': { color: '#3B82F6' }, transition: 'color 0.2s' }}
            >
              Aviso de Privacidad
            </MLink>
            <MLink
              component={Link}
              to="/legal/terminos-de-uso"
              underline="hover"
              sx={{ color: '#94A3B8', '&:hover': { color: '#3B82F6' }, transition: 'color 0.2s' }}
            >
              Términos de Uso
            </MLink>
            <MLink
              component={Link}
              to="/legal/politica-de-cookies"
              underline="hover"
              sx={{ color: '#94A3B8', '&:hover': { color: '#3B82F6' }, transition: 'color 0.2s' }}
            >
              Política de Cookies
            </MLink>
            <Button
              variant="contained"
              color="primary"
              href="https://helpdesk.rolsyssolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              sx={{ 
                px: 4,
                ml: { sm: 2 },
                background: 'rgba(59,130,246,0.1)',
                color: '#60A5FA',
                boxShadow: 'none',
                border: '1px solid rgba(59,130,246,0.3)',
                '&:hover': { background: 'rgba(59,130,246,0.2)', boxShadow: 'none' }
              }}
            >
              Soporte Helpdesk
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)', mb: 3 }} />

        <Typography variant="body2" align="center" sx={{ color: '#64748B' }}>
          © {new Date().getFullYear()} {site.name}. Todos los derechos reservados.
        </Typography>
      </Container>
    </Box>
  );
}
